export const AD_UNIT_TYPE = {
  THUMBNAIL: 'overlay_thumbnail',
  MEDIUM_RECTANGLE: 'medium_rectangle',
  BANNER: 'banner_320x50',
  INTERSTITIAL: 'interstitial',
  HEADER_AD: 'header_ad',
  FOOTER_AD: 'footer_ad',
  OPTIN_VIDEO: 'optin_video',
  IN_ARTICLE: 'in_article',
  STANDARD_BANNERS: 'standard_banners'
} as const;

export type AdUnitType = typeof AD_UNIT_TYPE[keyof typeof AD_UNIT_TYPE];

export function isMediumRectangleAdUnit(adUnitType?: string): boolean {
  return adUnitType === AD_UNIT_TYPE.MEDIUM_RECTANGLE;
}

export function isThumbnailAdUnit(adUnitType?: string): boolean {
  return adUnitType === AD_UNIT_TYPE.THUMBNAIL;
}

export function isHeaderAdUnit(adUnitType?: string): boolean {
  return adUnitType === AD_UNIT_TYPE.HEADER_AD;
}

export function isFooterAdUnit(adUnitType?: string): boolean {
  return adUnitType === AD_UNIT_TYPE.FOOTER_AD;
}

export function isInArticleAdUnit(adUnitType?: string): boolean {
  return adUnitType === AD_UNIT_TYPE.IN_ARTICLE;
}

export function isStandardBannersAdUnit(adUnitType?: string): boolean {
  return adUnitType === AD_UNIT_TYPE.STANDARD_BANNERS;
}

export function isBannerAdUnit(adUnitType?: string): boolean {
  return adUnitType === AD_UNIT_TYPE.BANNER;
}

export function isInterstitialAdUnit(adUnitType?: string): boolean {
  return adUnitType === AD_UNIT_TYPE.INTERSTITIAL;
}

export function isOptinVideoAdUnit(adUnitType?: string): boolean {
  return adUnitType === AD_UNIT_TYPE.OPTIN_VIDEO;
}

export function getOgyAdUnitParam(param: string): string | boolean | undefined {
  return (
    (window as any).OG_AD_UNIT_CONFIG &&
    (window as any).OG_AD_UNIT_CONFIG.params[param]
  );
}
